<script lang="ts" setup>
import { UiBtn } from '@shared/ui';

interface Props {
  error: {
    statusCode: number;
    message: string;
  };
}

defineProps<Props>();
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-4 bg-white p-8 rounded-xl w-full max-w-[562px] max-[444px]:h-full max-[444px]:rounded-none">
    <p class="text-[128px] font-bold leading-tight text-blue-600">
      {{ error.statusCode }}
    </p>
    <h1 class="text-2xl font-bold text-center max-[576px]:text-xl">
      Страница не найдена
    </h1>
    <p class="text-center">
      В адресе есть ошибка или страницы не существует. Попробуйте вернуться на
      главную страницу
    </p>
    <div class="mt-2">
      <UiBtn
        tag="a"
        color="primary"
        size="md"
        href="/"
        :external="false"
        label="На главную страницу"
      />
    </div>
  </div>
</template>
